import './App.css';
import GeneratorForm from './components/form/GeneratorForm';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
    return (
    <div className="App">
        <ErrorBoundary>
            <GeneratorForm />
        </ErrorBoundary>
    </div>
    );
}

export default App;
